import React from 'react';

export default function CartIcon({
  color = '#2D264B',
  w = '23',
  h = '21',
}: {
  color?: string;
  w?: string;
  h?: string;
}) {
  return (
    <svg
      width={w}
      height={h}
      viewBox='0 0 23 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.47778 0.568259C1.37731 0.166415 0.970103 -0.0778961 0.568259 0.0225748C0.166415 0.123046 -0.0778961 0.530252 0.0225748 0.932096L1.07442 5.13907L2.05323 9.22305C2.46942 10.9596 2.79702 12.3265 3.18576 13.3884C3.58453 14.4777 4.07353 15.3233 4.85811 15.9718C4.92582 16.0277 4.9948 16.0821 5.065 16.1349C5.87846 16.7468 6.81477 17.0252 7.96696 17.1591C9.09019 17.2897 10.4958 17.2897 12.2814 17.2896H12.875C14.42 17.2897 15.6363 17.2897 16.6161 17.1906C17.6197 17.0891 18.4454 16.8785 19.1886 16.4132C19.541 16.1925 19.8686 15.9342 20.1653 15.6429C20.8641 14.9569 21.2787 14.0955 21.6356 12.9785C21.8982 12.1569 22.1427 11.1517 22.4369 9.92512L22.51 9.62019C22.7272 8.71426 22.9062 7.9676 22.9753 7.36271C23.0471 6.73492 23.0178 6.13716 22.7044 5.59137C22.5704 5.35794 22.4028 5.14544 22.207 4.96069C21.7493 4.52874 21.1748 4.36094 20.5476 4.28441C19.9432 4.21066 19.1755 4.21068 18.2438 4.2107L2.38848 4.2107L1.47778 0.568259ZM3.50081 8.82712L2.7539 5.7107H18.1952C19.1877 5.7107 19.8632 5.71202 20.3659 5.77336C20.8562 5.83319 21.0572 5.93812 21.1775 6.05161C21.2665 6.13559 21.3427 6.23217 21.4036 6.33828C21.4859 6.48168 21.5411 6.70163 21.485 7.19237C21.434 7.63825 21.3056 8.20517 21.116 9.00018L13.7503 9.00018C13.3361 9.00018 13.0003 9.33596 13.0003 9.75018C13.0003 10.1644 13.3361 10.5002 13.7503 10.5002L20.7546 10.5002C20.6156 11.0667 20.489 11.5619 20.3639 12.0002H16.7503C16.3361 12.0002 16.0003 12.336 16.0003 12.7502C16.0003 13.1644 16.3361 13.5002 16.7503 13.5002H19.8371C19.6241 13.9629 19.3939 14.2982 19.1145 14.5725C18.8951 14.7878 18.6531 14.9787 18.3925 15.1418C17.9184 15.4387 17.3457 15.6091 16.4652 15.6982C15.5695 15.7888 14.429 15.7896 12.8339 15.7896H12.3292C10.4854 15.7896 9.1668 15.7885 8.14013 15.6692C7.13244 15.552 6.48818 15.3284 5.96664 14.9362C5.91475 14.8971 5.86376 14.8569 5.81372 14.8156C5.31069 14.3998 4.94309 13.8254 4.59434 12.8728C4.23902 11.9022 3.93056 10.6202 3.50081 8.82712Z'
        fill={color}
      />
      <path
        d='M10.224 19.6975C10.224 20.2789 9.75267 20.7502 9.17132 20.7502C8.58997 20.7502 8.11869 20.2789 8.11869 19.6975C8.11869 19.1162 8.58997 18.6449 9.17132 18.6449C9.75267 18.6449 10.224 19.1162 10.224 19.6975Z'
        fill={color}
      />
      <path
        d='M16.5397 19.6975C16.5397 20.2789 16.0685 20.7502 15.4871 20.7502C14.9058 20.7502 14.4345 20.2789 14.4345 19.6975C14.4345 19.1162 14.9058 18.6449 15.4871 18.6449C16.0685 18.6449 16.5397 19.1162 16.5397 19.6975Z'
        fill={color}
      />
    </svg>
  );
}
